import React from 'react';
import { Container, Badge, } from 'react-bootstrap';
import { Column } from 'react-table';
import { Table } from '../../components/DataTable';

import { useAsyncRetry } from 'react-use';
import api from '../../api';
import { ProfitRPLType } from '../../api/newApi/getProfit'
import classNames from 'classnames/bind';

import style from './index.module.css';

const cx = classNames.bind(style);

export interface Profited {
  cuid: string,
  campaignName: string | null;
}

const numberFormatter = (value: string) =>
  (+value).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
function useProfitInfo(cuid: string, retryToggle: boolean) {
  const { loading, value, retry } = useAsyncRetry(() => api.getProfitQuery({ cu_id: cuid }), [cuid, retryToggle]);
  const profit = React.useMemo(() => {
    return value?.rpl
  }, [loading]);
  const QueryTime = React.useMemo(() => {
    return value?.QueryTime ? value?.QueryTime : ""
  }, [loading]);


  return {
    retry,
    loading,
    value,
    profit,
    QueryTime,
  };
}
const Profited: React.FC<Profited> = ({
  cuid,
  campaignName,
}) => {
  const [retryToggle, setRetryToggle] = React.useState(false);
  const { loading: ProfitLoading, value, QueryTime, retry, } = useProfitInfo(cuid, retryToggle,)
React.useEffect(() => { (window.parent as any).resizeIframe() }, [value])
  const columns = React.useMemo<Column<ProfitRPLType>[]>(
    () => [
      {
        Header: "賣出時間",
        accessor: "st",
        sticky: "left",
        disableSortBy: true,
        Cell: cellInfo =>
          <><div>{cellInfo.cell.row.original.st}<br />{cellInfo.cell.row.original.stime}</div></>
      },
      {
        Header: "權證名稱",
        accessor: "name",
        disableSortBy: true
      },
      {
        Header: "權證代號",
        accessor: "sym",
        disableSortBy: true
      },
      {
        Header: "張數",
        accessor: "q",
        disableSortBy: true
      },
      {
        Header: "價格",
        accessor: "p",
        disableSortBy: true
      },
      {
        Header: "買入成本",
        accessor: "bc",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div>{numberFormatter(Math.round(cellInfo.cell.row.original.bc).toString())}</div>}
        </>
      },
      {
        Header: "賣出金額",
        accessor: "sa",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div>{numberFormatter(Math.round(cellInfo.cell.row.original.sa).toString())}</div>}
        </>
      },
      {
        Header: "損益",
        accessor: "pf",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx(cellInfo.cell.row.original.pf > 0 ? "red" : cellInfo.cell.row.original.pf < 0 ? "green" : "")}>{numberFormatter(Math.round(cellInfo.cell.row.original.pf).toString())}</div>}
        </>
      },
      {
        Header: "報酬率",
        accessor: "roi",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx(cellInfo.cell.row.original.roi > 0 ? "red" : cellInfo.cell.row.original.roi < 0 ? "green" : "")}>{cellInfo.cell.row.original.roi}</div>}
        </>
      },
      {
        Header: "手續費",
        accessor: "f",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div>{numberFormatter(Math.round(cellInfo.cell.row.original.f).toString())}</div>}
        </>
      },
      {
        Header: "稅",
        accessor: "t",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div>{numberFormatter(Math.round(cellInfo.cell.row.original.t).toString())}</div>}
        </>
      }
    ],
    []
  );
  return (
    <Container className={cx("container-left")} fluid="xl">
      <div className={cx("text-color", " container-left")}>
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="text-color bi bi-play" viewBox="0 0 16 16">
          <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
        </svg>
        目前盤別：{campaignName ? campaignName : "尚未選擇活動"}
      </div>
      <div className={cx("text-color", "container-left")}>
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
          <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
        </svg>
        已實現績效清單  <Badge className={cx("badge-box")} >{value?.rpl.length || 0}筆</Badge>
      </div>
      <div className={cx("updateTime")}>
        更新時間：{QueryTime || ""}
      </div>
      <Table columns={columns} data={value?.rpl || []} loading={ProfitLoading} pagination={true} />
    </Container >
  );
};


export default Profited;
